var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader'),_c('div',{staticClass:"main-cantainer"},[_c('router-view')],1),(_vm.$route.name === 'Home' || _vm.$route.name === 'aboutus')?_c('AppFooter'):_vm._e(),_c('Kefu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }